import React from "react";
import Modal from "react-modal";
import detailTabSwitchService from "../DetailTabSwitchService";
import { ProductDetailInfo } from "../ProductDetailPageTypeConfig";
import ProductErrorReportForm from "./ProductErrorReportForm";
import ProductErrorReportSubmitted from "./ProductErrorReportSubmitted";

interface ProductErrorReportModalProperties {
    readonly productDetailInfo: ProductDetailInfo;
    readonly onAfterClose?: () => void;
}

export default function ProductErrorReportModal({ productDetailInfo, onAfterClose }: ProductErrorReportModalProperties): React.JSX.Element {
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [isSubmitted, setIsSubmitted] = React.useState(false);

    const showModal = (): void => {
        setModalIsOpen(true);
    };

    const closeModal = (): void => {
        setIsSubmitted(false);
        setModalIsOpen(false);
    };

    const handleShowQuestionForm = (): void => {
        closeModal();
        detailTabSwitchService.showQuestionForm();
    };

    return (
        <>
            <div className="report-error" onClick={showModal}><i className="fa-solid fa-exclamation-triangle">&nbsp;</i>Našli
                jste v ceně nebo popisu chybu?
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                onAfterClose={onAfterClose}
                className="modal-dialog modal-transition"
                overlayClassName="react-modal-backdrop modal-transition"
            >
                <div className="modal-content">
                    <div className="modal-header empty">
                        <button type="button" className="close" onClick={closeModal}>
                            <i className="fa-solid fa-times"></i>
                        </button>
                    </div>
                    {isSubmitted
                        ? <ProductErrorReportSubmitted onClose={closeModal} />
                        : <ProductErrorReportForm
                            productDetailInfo={productDetailInfo}
                            onShowQuestionForm={handleShowQuestionForm}
                            onSubmitted={(): void => setIsSubmitted(true)} />}
                </div>
            </Modal>
        </>
    );
}
